// extracted by mini-css-extract-plugin
export var social_panel = "DefaultSidebar-module--social_panel--oNGZW";
export var social_button = "DefaultSidebar-module--social_button--0ebk+";
export var social_icon = "DefaultSidebar-module--social_icon--+3A0b";